module.exports = __webpack_public_path__ + "img/Balm1.89681186.jpg";